import { EMessagesActionTypes } from '../../actions/messages';
import { ERequestApiStatus, TAppState } from '../../types/appState';
import { EMobileLayoutActiveSide } from '../../types/mobileSide';
import { TReduxActions } from '../../types/redux/actions';
import { addNewChat } from '../../utils/addNewChat';
import { addMessagesInChat, setMessageReadStatus, synchronizationMessagesInChat } from '../../utils/messageUtils';

export function messagesReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EMessagesActionTypes.SetAsRead:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...state.openedChats[action.payload.chatId],
            chatMessages: setMessageReadStatus(
              action.payload.messagesMap,
              action.payload.messageIds,
              state.openedChats[action.payload.chatId]?.chatMessages || [],
            ),
          },
        },
      };

    case EMessagesActionTypes.SetMessagesPending: {
      const currentChatId = action.payload.chatId;
      const currentChat = state.chatList.chats.find(chat => chat.chatId === currentChatId);

      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId: action.payload.chatId,
        },
        openedChats: addNewChat({
          openedChats: state.openedChats,
          offer: currentChat?.offer,
          currentChatId,
          header: currentChat?.header,
        }),
        mobileSide: EMobileLayoutActiveSide.Center,
      };
    }
    case EMessagesActionTypes.SetMessagesFulfilled:
      return {
        ...state,
        openedChats: addMessagesInChat({
          openedChats: state.openedChats,
          messages: action.payload.messages,
          currentOpenedChatId: action.payload.chatId || (state.chatWindow.currentOpenedChatId as string),
          messagesMap: action.payload.messagesMap,
          userId: state.user.userId,
        }),
      };
    case EMessagesActionTypes.SetSynchronizationMessagesPending:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...state.openedChats[action.payload.chatId],
            status: ERequestApiStatus.Pending,
          },
        },
      };
    case EMessagesActionTypes.SetMessagesFailed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...state.openedChats[action.payload.chatId],
            status: ERequestApiStatus.Failed,
            error: action.payload.error,
          },
        },
      };
    case EMessagesActionTypes.SetSynchronizationMessagesFulfilled:
      return {
        ...state,
        openedChats: synchronizationMessagesInChat({
          openedChats: state.openedChats,
          messages: action.payload.messages,
          chatId: action.payload.chatId,
          messagesMap: action.payload.messagesMap,
          userId: state.user.userId,
        }),
      };
    default:
      return state;
  }
}
